import { cn } from '@eliadmin/core/src/utils/style-utils';

export const Heading = ({
  title,
  className,
  as: Tag = 'h2',
}: {
  title: string;
  className?: string;
  as?: 'h1' | 'h2';
}) => {
  return (
    <Tag className={cn('text-3xl font-bold text-foreground sm:text-4xl', className)}>{title}</Tag>
  );
};
